import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("TagAddInput")
export class TagAddInput {
    @JsonProperty("mediaId", String, true)
    public mediaId: string = JsonPropertyEmpty;

    @JsonProperty()
    public label: string = JsonPropertyEmpty;

    @JsonProperty()
    public slug: string = JsonPropertyEmpty;

    public constructor(args?: Partial<TagAddInput>) {
        Object.assign(this, args);
    }
}
